import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import LoginPage from './LoginPage';

import { setSignupSecondStep as setSignupSecondStepAction } from '../../actions/lookup';
import { trackBrandLogoClicked as trackBrandLogoClickedAction } from '../../actions/gaTracking';
import { setPasswordlessCreateAccountFlow as setPasswordlessCreateAccountFlowAction } from '../../actions/passwordless';
import {
    clearAuthNotification as clearAuthNotificationAction,
    redirectToSignUp as redirectToSignUpAction,
    cleanSocialAuthenticationData as cleanSocialAuthenticationDataAction,
} from '../../actions/auth';
import {
    socialLogInUser as socialLogInUserAction,
    loadGoogleOneTap as loadGoogleOneTapAction,
} from '../../actions/social';
import {
    cancelToS as cancelToSAction,
    acceptSocialToS as acceptToSAction,
} from '../../actions/tos';

const _mapStateToProps = ({ authentication, social }) => ({
    socialSSOSettings: social.socialSSOSettings,
    launchAsyncStrategyForAuthSocialScripts:
        authentication.featureFlags.launchAsyncStrategyForAuthSocialScripts,
    launchGoogleOneTapWeb: authentication.featureFlags.launchGoogleOneTapWeb,
    launchPasswordlessLogin:
        authentication.featureFlags.launchPasswordlessLogin,
    launchLoginWithVerificationCode:
        authentication.featureFlags.launchLoginWithVerificationCode,
});
const _mapDispatchToProps = {
    clearAuthNotification: clearAuthNotificationAction,
    onSocialLogInUser: socialLogInUserAction,
    handleSignUpClick: redirectToSignUpAction,
    setSignupSecondStep: setSignupSecondStepAction,
    cancelToS: cancelToSAction,
    acceptSocialToS: acceptToSAction,
    cleanSocialAuthenticationData: cleanSocialAuthenticationDataAction,
    loadGoogleOneTap: loadGoogleOneTapAction,
    handleTrackBrandLogoClick: trackBrandLogoClickedAction,
    setPasswordlessCreateAccountFlow: setPasswordlessCreateAccountFlowAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(LoginPage),
);
